/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersnoteplaceholder2Inputs */

const en_partnersnoteplaceholder2 = /** @type {(inputs: Partnersnoteplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. how you know each other`)
};

const de_partnersnoteplaceholder2 = /** @type {(inputs: Partnersnoteplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. woher ihr euch kennt`)
};

/**
* | output |
* | --- |
* | "e.g. how you know each other" |
*
* @param {Partnersnoteplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersnoteplaceholder2 = /** @type {((inputs?: Partnersnoteplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersnoteplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersnoteplaceholder2(inputs)
	return de_partnersnoteplaceholder2(inputs)
});
export { partnersnoteplaceholder2 as "partnersNotePlaceholder" }